import {
  Button,
  Card,
  CardBody,
  CardHeader,
  StarburstIcon,
} from "@flick/fep-library";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FRIEND_GET_FRIEND_CREDIT_AMOUNT } from "utils/constants";
import { replaceContentParams } from "utils/stringFormat/contentParams";

import content from "./static/content.json";

const { promoCreditAmount, cardHeaderText, cardBody, buttonText } = content;

// eslint-disable-next-line no-shadow
export enum CardColors {
  pink = "pink",
  yellow = "yellow",
}

type FriendGetFriendCardProps = {
  cardColor?: CardColors;
  previousPath: string;
};

export const FriendGetFriendCard: React.FC<FriendGetFriendCardProps> = ({
  cardColor = CardColors.pink,
  previousPath,
}) => {
  const navigate = useNavigate();

  const promoAmount = useMemo(() => {
    return replaceContentParams(promoCreditAmount || "", {
      creditAmount: FRIEND_GET_FRIEND_CREDIT_AMOUNT,
    });
  }, []);

  const cardBodyText = useMemo(() => {
    return replaceContentParams(cardBody || "", {
      creditAmount: FRIEND_GET_FRIEND_CREDIT_AMOUNT,
    });
  }, []);

  return (
    <Card
      cardColor={cardColor}
      cardPaddingType="compact"
      cardBorderStyle="shadow"
    >
      <CardHeader extraHeaderClasses="card__header--display-face">
        <p>{cardHeaderText}</p>
      </CardHeader>
      <CardBody
        bodyRightContent={
          <StarburstIcon textColor={cardColor}>
            <p className="aria-hidden starburst__icon-text">
              {promoAmount}{" "}
              <span className="starburst__icon-sub-text">credit</span>
            </p>
          </StarburstIcon>
        }
        extraBodyClasses={`h5`}
      >
        <section>
          <article className="card__body-side-content-text">
            {cardBodyText}
          </article>
          <Button
            extraClasses={`text__colour--${cardColor}`}
            onClick={() =>
              navigate("/account/friend-get-friend", {
                state: { previousPath },
              })
            }
          >
            {buttonText}
          </Button>
        </section>
      </CardBody>
    </Card>
  );
};
